import React, {Component} from 'react';
import {connect} from 'react-redux';

import Accordeon from '../../../../../components/Accordeon/accordeon';

import TripProviderForm from './TripProviderForm';
import TripProgrammingForm from './TripProgrammingForm';
import TripPlantEntry from './TripPlantEntry';
import TripPlantExit from './TripPlantExit';
import TripDispatch from './TripDispatch';
import TripDocControl from './TripDocControl';
import TripDischarge from './TripDischarge';
import TripSummary from './TripSummary';
import helpers from '../../../../../utils/helpers';


class TripClosed extends Component {

    componentDidMount(){
        window.initializeCollapsible();
    }

    render() {
        let {trip} = this.props;
        if(!trip)return <div />;

        let isProvider = helpers.isUserProvider(this.props.user);

        if(isProvider || !trip.terminal.discharge_process){
            return (
                <div>
                    <ul className="collapsible no-margin black-collapsible" data-collapsible="expandable">
                        {trip.incoterm.id === 'CIF' &&
                        <Accordeon name={'Viaje'} active bordered>
                            <TripProviderForm trip={trip} />
                        </Accordeon>
                        }

                        {trip.incoterm.id === 'FOB' &&
                        <Accordeon name={'Viaje'} active bordered>
                            <TripProgrammingForm trip={trip}/>
                        </Accordeon>
                        }

                        {trip.incoterm.id === 'FOB' &&
                        <Accordeon name={'Despacho'} active bordered>
                            <TripDispatch trip={trip}/>
                        </Accordeon>
                        }

                    </ul>
                </div>
            );
        }

        return (
            <div>
                <TripSummary trip={trip} />
                <ul className="collapsible no-margin black-collapsible" data-collapsible="expandable">
                    {trip.incoterm.id === 'CIF' &&
                    <Accordeon name={'Información del viaje'} active bordered>
                        <TripProviderForm trip={trip} />
                    </Accordeon>
                    }

                    {trip.incoterm.id === 'FOB' &&
                    <Accordeon name={'Información del viaje'} active bordered>
                        <TripProgrammingForm trip={trip}/>
                    </Accordeon>
                    }

                    {trip.incoterm.id === 'FOB' &&
                    <Accordeon name={'Despacho'} bordered>
                        <TripDispatch trip={trip}/>
                    </Accordeon>
                    }

                    <Accordeon name={'Ingreso a Terminal'} bordered>
                        <TripPlantEntry trip={trip} />
                    </Accordeon>


                    <Accordeon name={'Control de Documentación'} bordered>
                        <TripDocControl trip={trip} />
                    </Accordeon>

                    {trip.discharge && trip.discharge.length > 0}
                    <Accordeon name={'Descarga'} bordered>
                        <TripDischarge trip={trip} />
                    </Accordeon>

                    <Accordeon name={'Egreso'} bordered>
                        <TripPlantExit trip={trip} />
                    </Accordeon>

                </ul>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};

export default connect(mapStateToProps)(TripClosed);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Done/index.js